import { create } from 'zustand';
import { FilterState } from '../DataTable';

/**
 * What one control currently shows. A list for `select-multiple`, whose value
 * is a set of keys rather than one — `applyFilterState` already copied such
 * arrays straight out of the filter state, so this widens the type to the
 * values that were being stored in it all along.
 */
type SmartFilterValue = string | number | string[];

interface SmartFilterValueStore {
    values: Record<string, SmartFilterValue>;
    reset: () => void;
    applyFilterState: (filterState: FilterState) => void;
    setValue: (key: string, value: SmartFilterValue) => void;
}

const useSmartFilterValueStore = create<SmartFilterValueStore>((set) => ({
    values: {},
    reset: () => set({ values: {} }),
    applyFilterState: (filterState: FilterState) => {
        const newValues: Record<string, SmartFilterValue> = {};
        Object.entries(filterState).forEach(([key, value]) => {
            if (typeof value === 'object' && value !== null && 'value' in value) {
                newValues[key] = value.value as SmartFilterValue;
            } else if (typeof value === 'object' && value !== null && ('from' in value || 'to' in value)) {
                if ('from' in value) {
                    newValues[`${key}:from`] = (value as any).from as SmartFilterValue;
                }
                if ('to' in value) {
                    newValues[`${key}:to`] = (value as any).to as SmartFilterValue;
                }
            }
        });
        set({ values: newValues });
    },
    setValue: (key: string, value: SmartFilterValue) =>
        set((state) => ({
            values: {
                ...state.values,
                [key]: value
            }
        }))
}));

export default useSmartFilterValueStore;
